/**
 * 工单月报搜索组件
 * zxw
 * 创建时间：
 * 修改时间：2026-07-09
*/

import { useState, useCallback } from "react";
import { Modal, DatePicker, Flex, Space, Typography } from "antd";

/** 
* 日期样式
*/
import dayjs from 'dayjs';
import { LastMonth } from '../../incs/FunHelper.js';

import WOMREntity from './WOMREntity';

const { MonthPicker } = DatePicker;
const { Text } = Typography;

const MRSearch = (props) => {
    const { open, setOpen, record, preGroup, btnLists } = props;

    const [month, setMonth] = useState(LastMonth());
    const [openWOMREntity, setOpenWOMREntity] = useState(false);

    const setOpenWOMREntityModel = useCallback((open) => {
        setOpenWOMREntity(false);
        setOpen(false);
    }, [setOpen])


    const cancel = () => {
        setOpen(false);
        setMonth(LastMonth());
    }

    /***
     * 工单月报实体
    */
    const ok = () => {
        setOpenWOMREntity(true);
    }
    return (
        <>
            <Modal
                closable={false}
                open={open}
                keyboard={true}
                width={400}
                onOk={ok}
                onCancel={cancel}
                okText="确定"
                cancelText="取消"
            >
                <Flex vertical gap='small'>
                    <Space size={0}><Text>选择月份</Text><Text type='danger'>*</Text></Space>
                    <MonthPicker
                        style={{ width: "100%" }}
                        placeholder='请选择月份'
                        onChange={(_, dateString) => setMonth(dateString)}
                        value={dayjs(month, 'YYYY-MM')}
                    />
                </Flex>
            </Modal>
            {
                record && <WOMREntity
                    preGroup={preGroup}
                    btnLists={btnLists}
                    open={openWOMREntity}
                    setOpen={setOpenWOMREntityModel}
                    month={month}
                    record={record}
                />
            }
        </>
    );
}

export default MRSearch;